<template>


    <!-- About view start -->
    <section class="px-12 lg:px-32 py-56 mb-8 border-t border-stone-500 relative text-justify object-contain" id="aboutView">
        <!-- Main text start -->
         
        <div class="flex-1">
            <h1 class="uppercase text-5xl xl:text-7xl mb-4 about-title object-contain">
                {{ $t('aboutUsView.about') }}
                <span class="companyName"><strong>Virtus Consulting</strong></span>
            </h1><br>
            <p class="xl:w-1/2 text-stone-500 mb-8 object-contain about-text">{{ $t('aboutUsView.we') }}
            </p>
            <br><br>
        </div>
        <!-- Main text end -->


        <div class="flex gap-8 flex-col md:flex-row mission">
            <!-- Mission text start -->
            <h1 class="capitalize text-5xl mb-4 font-semibold services-title">
                <strong>{{ $t('aboutUsView.mission') }}</strong>
            </h1>
            <p class="xl:w-1/2 text-stone-500 mb-8 services-text text-justify">
                {{ $t('about.mission') }}
            </p>
            <!-- Mission text end -->
        </div>
        <br><br>

        <div class="flex gap-8 flex-col md:flex-row vision">
            <!-- Vision text start -->
            <h1 class="capitalize text-5xl mb-4 font-semibold services-title">
                <strong>{{ $t('aboutUsView.vision') }}</strong>
            </h1>
            <p class="xl:w-1/2 text-stone-500 mb-8 services-text text-justify">
                {{ $t('about.vision') }}
            </p>
            <!-- Vision text end -->
        </div>

        <br><br>

        <div class="flex gap-8 flex-col md:flex-row vision">
            <!-- Policy text start -->
            <h1 class="capitalize text-5xl mb-4 font-semibold services-title">
                <strong>{{ $t('aboutUsView.policy') }}</strong>
            </h1>
            <p class="xl:w-1/2 text-stone-500 mb-8 services-text text-justify">
                {{ $t('aboutUsView.guarantee') }}
            </p>
            <!-- Policy text end -->
        </div>

        <br><br>
        <div class="flex gap-8 flex-col md:flex-row vision">
            <!-- values text start -->
            <h1 class="capitalize text-5xl mb-4 font-semibold services-title">
                <strong>{{ $t('aboutUsView.values') }}</strong>
            </h1>
            <ul class="xl:w-1/2 text-stone-500 mb-8 services-text text-justify">
                <li>{{ $t('aboutUsView.value1') }}</li><br>
                <li>{{ $t('aboutUsView.value2') }}</li><br>
                <li>{{ $t('aboutUsView.value3') }}</li><br>
                <li>{{ $t('aboutUsView.value4') }}</li><br>
                <li>{{ $t('aboutUsView.value5') }}</li>
            </ul>
            <!-- values text end -->
        </div>

        <br>
        <!-- invitation text start -->
        <div><strong>{{ $t('about.trust') }}</strong></div>
        <!-- invitation text end -->

    <!-- Contact section start 
        <contact-section></contact-section>
    Contact section end -->
    </section>

    <!-- WhatsApp Floating Icon start -->
    <a :href="'https://wa.me/' + wppNumber" class="whatsapp-float" target="_blank">
        <i class="fab fa-whatsapp"></i>
    </a>
    <!-- WhatsApp Floating Icon end -->

    <!-- About view end -->
</template>

<script>
//import ContactSection from "@/sections/ContactSection.vue";
export default {
  //components: {
    //ContactSection,
  //},
  data() {
    return {
      wppNumber: "17864138919",
    };
  },
};
</script>

<style scoped>

#aboutView {
    background-image: url('../src/assets/logo_only.svg');
    background-color: rgba(255, 255, 255, 0.9); /* El último valor controla la transparencia */
    background-blend-mode: overlay; /* Esto ayuda a que la imagen y el color se mezclen mejor */
    background-attachment: fixed;
    background-position: right; /* Centra la imagen en el fondo */
    background-repeat: no-repeat; /* Evita que la imagen se repita */
    z-index: -1; /* Coloca la imagen detrás del contenido */
    background-size: 60% 60%; /* Ancho y altura del 50% del contenedor */
}
.about-title {
    color: #132e63;
    text-align: left;
}

@media (max-width: 653px) {
  .about-title {
    font-size: 10vw !important;
  }
  
 }

.about-text {
    color: #051328 !important;
}

@import '~@fortawesome/fontawesome-free/css/all.css';

.whatsapp-float {
    position: fixed;
    width: 60px;
    height: 60px;
    bottom: 40px;
    right: 40px;
    background-color: #25d366;
    color: #FFF;
    border-radius: 50px;
    text-align: center;
    font-size: 30px;
    box-shadow: 2px 2px 3px #999;
    z-index: 1000; 
    display: flex;
    align-items: center;
    justify-content: center;
}

.whatsapp-float i {
    font-size: 30px;
}
</style>